module.exports = __webpack_public_path__ + "static/media/mimi8.6646a3de.gif";